import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { SectionContainer } from "@/components/marketing/SectionContainer";
import { usePageMeta } from "./usePageMeta";

interface ComingSoonProps {
  title: string;
  body?: string;
}

export function ComingSoon({ title, body }: ComingSoonProps) {
  usePageMeta({ title, description: body ?? "Coming soon from VirtualDesk.ai." });
  return (
    <SectionContainer>
      <div className="max-w-xl mx-auto text-center py-20">
        <div className="inline-flex rounded-lg bg-brand-violet/15 p-3 text-brand-violet">
          <Clock className="h-8 w-8" />
        </div>
        <h1 className="mt-6 font-display text-5xl md:text-6xl tracking-wide text-brand-ink">
          {title}
        </h1>
        <p className="mt-4 text-base text-brand-ink/70 leading-relaxed">
          {body ?? "This page is launching soon. In the meantime, try the home page or contact us."}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild variant="primary">
            <Link to="/">Back to home</Link>
          </Button>
          <Button asChild variant="outline" className="border-white/20 text-brand-ink hover:bg-white/5">
            <Link to="/contact">Contact us</Link>
          </Button>
        </div>
      </div>
    </SectionContainer>
  );
}
